import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-battery-performance-metrics',
	templateUrl: './battery-performance-metrics.component.html',
	styleUrls: ['./battery-performance-metrics.component.css']
})
export class BatteryPerformanceMetricsComponent {
	@Input() batteryPerformanceMetrics: any = {};
	@Input() chargingMetrics: any = {};
	@Input() siteChargingType: number = 0;

	ChargingType = {
		CONVENTIONAL: 0,
		FAST: 1
	};
}
